var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "19",
        viewBox: "0 0 16 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13.0073 3.36784C12.1359 2.49641 10.7216 2.49641 9.85015 3.36784L3.27872 9.93927C1.77515 11.4428 1.77515 13.8786 3.27872 15.3821C4.78229 16.8857 7.218 16.8857 8.72158 15.3821L14.1501 9.95356C14.5394 9.56427 15.1751 9.56427 15.5644 9.95356C15.9537 10.3428 15.9537 10.9786 15.5644 11.3678L10.1359 16.7964C7.85015 19.0821 4.15015 19.0821 1.86443 16.7964C-0.421282 14.5107 -0.421282 10.8107 1.86443 8.52499L8.43586 1.95356C10.0894 0.299986 12.768 0.299986 14.4216 1.95356C16.0751 3.60713 16.0751 6.2857 14.4216 7.93927L8.13586 14.225C7.11443 15.2464 5.45729 15.2464 4.43586 14.225C3.41443 13.2036 3.41443 11.5464 4.43586 10.525L9.57872 5.38213C9.968 4.99284 10.6037 4.99284 10.993 5.38213C11.3823 5.77141 11.3823 6.40713 10.993 6.79641L5.85015 11.9393C5.61086 12.1786 5.61086 12.5714 5.85015 12.8107C6.08943 13.05 6.48229 13.05 6.72158 12.8107L13.0073 6.52499C13.8787 5.65356 13.8787 4.23927 13.0073 3.36784Z",
          fill: "currentcolor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }